import { createFileRoute } from "@tanstack/react-router";
import { matchingApiRoute } from "@/features/matching";

export const Route = createFileRoute("/api/match/$listingId")({
    ...matchingApiRoute,
});
